export default "__VITE_ASSET__BspSPdZp__"